import * as Request from '../../../request'
import * as CommunityConfig from '../../community-config'
import * as NewsbriefConstants from '../constants'
import * as NewsbriefTypes from '../types'
import * as NewsbriefUtils from '../utils'
import * as Constants from './constants'

type CountsAction = NewsbriefTypes.UpdateStateAction &
  Request.RequestAction &
  Request.SuccessAction

export const reducer = (state: NewsbriefTypes.CommunityConfigurationState = null, action: CountsAction) => {
  switch (action.type) {
    case Request.successConstant(NewsbriefConstants.FETCH_COMMUNITY_CONFIG):
      const configs = CommunityConfig.configsFromResponse(action.payload.response)
      return NewsbriefUtils.payloadDataToState(configs, [], Constants.ALL_CONTENT_KEYS)
    case Constants.UPDATE_NEWSBRIEF_COUNT:
      return NewsbriefUtils.updateState(state, action)
    case Constants.ADD_NEWSBRIEF_COUNT:
      return NewsbriefUtils.addState(state, action)
    case Request.requestConstant(NewsbriefConstants.FETCH_COMMUNITY_CONFIG):
      return null
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/pages/newsbrief/counts/reducer.ts